<template>
  <div>

    <!--top row(overall price price + vat etc)-->
    <div style="display: flex; flex-direction: column; margin-bottom: 50px;">
        <div style="display: flex; justify-content: space-evenly; color: black; font-weight: 450; font-size: 12px;">
          <div class="item-title">Overall price</div>
          <div class="item-title">Price + VAT</div>
          <div class="item-title">Discount</div>
          <div class="item-title">P.after discount</div>
          <div class="item-title">Est. install time</div>
          <div class="item-title">Stat. install time</div>
          <div class="item-title">Items</div>
        </div>

        <div style="display: flex; justify-content: space-evenly; margin-top: 2px;">
          <div class="item">{{Intl.NumberFormat('he-IL', { style: 'currency', currency: 'USD' }).format(total.price)  }}</div>
          <div class="item"> {{ Intl.NumberFormat('he-IL', { style: 'currency', currency: 'USD' }).format(total.priceAndVat) }}</div>
          <div class="item">{{ total.discount }}</div>
          <div class="item">{{ total.priceAfterDiscount }}</div>
          <div class="item">{{ total.estInstallTime }}</div>
          <div class="item">{{ total.statInstallTime }}</div>
          <div class="item">{{ total.items }}</div>
        </div>
    </div>
    <!--add button-->
    <div style="margin-bottom: 30px; display: flex; max-width: 30%; margin-left: 40%">
      <button class="btn btn-sm add-button" @click="addRow()"><i class="fas fa-plus"></i></button>
    </div>
    <!--new row inputs-->
    <div style="display: flex;">
      <!--    <input-component v-for="(input, index) in data" :key="index" :input-object="input" @dataChange="handleData"></input-component>-->
      <div class="form-group">
        <label>
          Brand
<!--          <input placeholder="Company..." type="text" class="form-control"  v-model="newOrder.company">-->
          <select
              v-model="newOrder.brand"
              id="brand"
              class="form-control"
              style="padding: 0;"
          >
            <option
                v-for="(item, index) in getBrands()"
                :value="item.id"
                :key="index"
            >
              {{item.name}}
            </option>
          </select>
        </label>
      </div>

      <div class="form-group">
        <label>
          Category
          <select
              v-model="newOrder.category"
              id="category"
              class="form-control"
              style="padding: 0;"
          >
            <option
                v-for="(item, index) in inventoryItems.filter(i => i.brand_id === newOrder.brand)"
                :value="item.id"
                :key="index"
            >
              {{item.category.category}}
            </option>
          </select>
        </label>
      </div>

      <div class="form-group">
        <label>
          S/N
          <input placeholder="S/N..." type="text" class="form-control" v-model="newOrder.sn">
        </label>
      </div>

      <div class="form-group">
        <label>
          Type
          <input placeholder="type..." type="text" class="form-control" v-model="newOrder.type">
        </label>
      </div>

      <div class="form-group">
        <label>
          Languages
          <select
              v-model="newOrder.languages"
              id="languages"
              class="form-control"
              style="padding: 0;"
          >

            <option
                v-for="(lang, index) in dictionaries.general.languages"
                :value="lang.id"
                :key="index"
            >
              {{ lang.name }}
            </option>
          </select>
        </label>
      </div>

      <div class="form-group">
        <label>
          Country
          <select
              v-model.number="newOrder.country"
              id="country"
              class="form-control"
              style="padding: 0;"
          >
            <option
                value="1"
            >
              Israel
            </option>

            <option
                value="2"
            >
              U.S.A
            </option>

            <option
                value="3"
            >
              Russia
            </option>
          </select>
        </label>
      </div>

      <div class="form-group">
        <label>
          Quantity
          <input placeholder="Quantity..." type="number" class="form-control" v-model.number="newOrder.quantity">
        </label>
      </div>

      <div class="form-group">
        <label>
          Price
          <input placeholder="Price..." type="number" class="form-control" v-model.number="newOrder.price">
        </label>
      </div>

    </div>

    <div v-if="rows.length > 0">
      <div style="display: flex; flex-direction: column; margin-bottom: 50px;">
        <div style="display: flex; justify-content: space-evenly; color: black; font-weight: 450; font-size: 12px;">
          <div class="item-title">Brand</div>
          <div class="item-title">category</div>
          <div class="item-title">s/n</div>
          <div class="item-title">type</div>
          <div class="item-title">languages</div>
          <div class="item-title">country</div>
          <div class="item-title">quantity</div>
          <div class="item-title">price</div>
        </div>


        <div style="display: flex; justify-content: space-evenly; margin-top: 2px;" v-for="(row, index) in rows" :key="index">
          <div class="item-title">{{ row.brand }}</div>
          <div class="item-title">{{ row.category }}</div>
          <div class="item-title">{{ row.sn }}</div>
          <div class="item-title">{{ row.type }}</div>
          <div class="item-title">{{row.languages}}</div>
          <div class="item-title">{{ row.country }}</div>
          <div class="item-title">{{row.quantity}}</div>
          <div class="item-title">{{ Intl.NumberFormat('he-IL', { style: 'currency', currency: 'USD' }).format(row.price *  row.quantity) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import InputComponent from "./Input.component"
import apiClientCreator from "@/helpers/api/request";
import moment from "moment";
import {mapActions, mapState} from "vuex";
export default {
  name: "Form.component",
  props:{
    data: {
      type: Array,
      default: () => []
    },
    saveOrder:{
      type: Boolean,
      default: false
    },
    filesIds:{
      type: Array,
      default: () => []
    }
  },
  // components: {InputComponent},

  mounted() {
    apiClientCreator("projects/inventory/list")
        .get("")
        .then(res => {
          this.inventoryItems = res.data.data;
        });
  },
  computed: {
    ...mapState("clients", [
      "dictionaries",
    ]),
    ...mapActions("clients", ["getGeneralDictionary"])
  },
  data() {
    return{
      inventoryItems: [],
      newOrder: {
        brand: null,
        category: null,
        sn: null,
        type: null,
        languages: null,
        country: null,
        quantity: null,
        price: null
      },
      rows: [],
      total: {
        price: 0,
        priceAndVat: 0,
        discount: 0,
        priceAfterDiscount: 0,
        estInstallTime: 0,
        statInstallTime: 0,
        items: 0
      }
    }
  },
  methods: {
    getBrands(){
      //console.log( [...new Set(this.inventoryItems.map(item => item.brand.id))])
      // console.log(new Set(this.inventoryItems.map(i => i.brand)))
     return  new Set(this.inventoryItems.map(i => i.brand));
    },
    handleData(data){
      this.newOrder = Object.assign({}, this.newOrder, data);
    },
    addRow(){
      this.rows.push(this.newOrder)
      this.newOrder = {
        brand: null,
        category: null,
        sn: null,
        type: null,
        languages: null,
        country: null,
        quantity: null,
        price: null
      }
    },
    calcTotals(){
      let p = 0;
      let i = 0;
      let pnv = 0;

      this.rows.forEach(row => {
         p = p + (row.price * row.quantity);
         i = i + row.quantity;
         pnv = pnv + (p * 1.17);
      })
      this.total.price = p;
      this.total.items = i;
      this.total.priceAndVat = pnv

    }
  },
  watch:{
    'newOrder.brand': function(){

    },
    saveOrder: function(){
      if(this.saveOrder === true){
        apiClientCreator("projects/orders/save_order").post("", {order: this.newOrder, files_ids: this.filesIds}).then(res => {
          this.$emit('order_saved')
          this.newOrder = {}
        });
      }
    },

    rows: function(){
      this.calcTotals()
    }
  }
}
</script>

<style scoped>
.form-group{
  width: 100%;
  margin-right: 5px;
}
.form-control {
  border: 1px none #333;
  border-bottom-style: solid;
  display: block;
  width: 100%;
  height: 32px;
  padding: 0;
  margin-bottom: 15px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-radius: 0;

}

label {
  display: block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 11px;
}

.item{
  width: 100%;
  text-align: center;
}

.item-title{
  width: 100%;
  text-align: center;
  border: 1px solid cornflowerblue;
}
.add-button{
  width: 50%;
  border-radius: 0;
  background-color: cornflowerblue;
  color: white
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>